var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Root as RootModel } from '@/models/Root';
import PageHeader from '@/components/page-header/PageHeader';
import { fileToBase64 } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import ErrorHandler from '@/support/ErrorHandler';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
import { RolesEnum } from '@/items/Roles';
let Root = class Root extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Root';
        this.isEditing = false;
        this.isEditingDob = false;
        this.root = new RootModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get breadcrumbs() {
        return [{ name: this.$tc('roles.user', 2) }, { name: this.$tc('roles.root', 2), path: '/super-administrators' }, { name: this.root.name || '', path: this.$route.path }];
    }
    mounted() {
        new RootModel().find(this.$route.params.id).then((root) => {
            this.root = root;
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.root.password = this.password.new;
        }
        const payload = this.root.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.root
            .include(['root', 'roles'])
            .update(payload)
            .then((root) => {
            this.resetPassword();
            this.root = root;
            this.updateCurrentUser(root);
        });
    }
    resetPassword() {
        delete this.root.password;
        delete this.root.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    updateCurrentUser(root) {
        if (root.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', root);
        }
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const rootWithDataObjects = await new RootModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (rootWithDataObjects) {
            this.baseImage = rootWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    avatarChanged(imageUrl) {
        this.root
            .include(['root', 'roles'])
            .update({ avatar: imageUrl })
            .then((root) => {
            this.root.avatar = imageUrl;
            this.updateCurrentUser(root);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.root.has_mfa_token;
    }
    async removeMfa() {
        if (this.root) {
            const root = await this.root
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (root) {
                this.$set(this.root, 'has_mfa_token', false);
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Root = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Root);
export default Root;
